import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme) => ({
  similarityContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#fff",
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(3),
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  similarityScore: {
    fontSize: "1.2rem",
    fontWeight: "bold",
  },
  buttonContainer: {
    display: "flex",
    gap: theme.spacing(1),
  },
  rejectButton: {
    color: "#f44336",
    borderColor: "#f44336",
    "&:hover": {
      backgroundColor: "#f44336",
      color: "#fff",
    },
  },
  mergeButton: {
    backgroundColor: "#2196f3",
    color: "#fff",
    // borderColor: "#2196f3",
    border: "1px solid #2196f3",
    "&:hover": {
      backgroundColor: "#fff",
      color: "#2196f3",
    },
  },
}));

export default function SimilarityHeader({
  similarityScore,
  onReject,
  onMerge,
  isActionLoading = false,
}) {
  const classes = useStyles();

  return (
    <Box className={classes.similarityContainer}>
      <Typography className={classes.similarityScore}>
        Sim: {similarityScore.toFixed(5)}
      </Typography>
      <div className={classes.buttonContainer}>
        <Button
          className={classes.rejectButton}
          variant= "outlined"
          onClick={onReject}
          disabled={isActionLoading}
        >
          Reject
        </Button>
        <Button
          className={classes.mergeButton}
          variant="contained"
          onClick={onMerge}
          disabled={isActionLoading}
        >
          Merge
        </Button>
      </div>
    </Box>
  );
}
